"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.queueMutation = queueMutation;
exports.dequeueMutation = dequeueMutation;
exports.optimisticCache = optimisticCache;
exports.getStaleEntities = getStaleEntities;
exports.setStaleEntities = setStaleEntities;
const GraphQLEntityCache = __importStar(require("gql-cache"));
const GQLCachePatch = __importStar(require("gql-cache-patch"));
const GraphQLAddRemoveFields = __importStar(require("graphql-add-remove-fields"));
const ts_exhaustive_check_1 = require("ts-exhaustive-check");
function queueMutation(queueMutationDescription, mutationsQueue) {
    switch (queueMutationDescription.type) {
        case "AddToQueueMutationDescription": {
            return Object.assign(Object.assign({}, mutationsQueue), { queuedMutations: mutationsQueue.queuedMutations.concat(queueMutationDescription.mutation) });
        }
        case "AddToQueueWithTagMutationDescription": {
            return Object.assign(Object.assign({}, mutationsQueue), { queuedMutations: mutationsQueue.queuedMutations.concat(Object.assign(Object.assign({}, queueMutationDescription.mutation), { tag: queueMutationDescription.tag })) });
        }
        case "AddToQueueReplaceTagMutationDescription": {
            return Object.assign(Object.assign({}, mutationsQueue), { queuedMutations: mutationsQueue.queuedMutations
                    .filter((qm) => qm.tag === undefined || qm.tag !== queueMutationDescription.tag)
                    .concat(Object.assign(Object.assign({}, queueMutationDescription.mutation), { tag: queueMutationDescription.tag })) });
        }
        case "AddToQueueReplaceTagAndConcatOptimisticMutationDescription": {
            const newQueuedMutations = [];
            if (mutationsQueue.queuedMutations.length > 0) {
                for (const queuedMutation of mutationsQueue.queuedMutations) {
                    if (queuedMutation.tag === undefined ||
                        queuedMutation.tag !== queueMutationDescription.tag) {
                        newQueuedMutations.push(queuedMutation);
                        continue;
                    }
                    newQueuedMutations.push(Object.assign(Object.assign({}, queueMutationDescription.mutation), { tag: queueMutationDescription.tag, optimisticCachePatches: (queuedMutation.optimisticCachePatches || []).concat(queueMutationDescription.mutation.optimisticCachePatches || []) }));
                }
            }
            else {
                newQueuedMutations.push(Object.assign(Object.assign({}, queueMutationDescription.mutation), { tag: queueMutationDescription.tag }));
            }
            return Object.assign(Object.assign({}, mutationsQueue), { queuedMutations: newQueuedMutations });
        }
        default: {
            (0, ts_exhaustive_check_1.exhaustiveCheck)(queueMutationDescription);
            return mutationsQueue;
        }
    }
}
function dequeueMutation(mutation, mutationsQueue) {
    return Object.assign(Object.assign({}, mutationsQueue), { queuedMutations: mutationsQueue.queuedMutations.filter((m) => m !== mutation) });
}
function optimisticCache(mutationsQueue, entities) {
    const mutationsWithOptimisticResponse = mutationsQueue.queuedMutations.filter((x) => x.optimisticResponse || x.optimisticCachePatches);
    if (mutationsWithOptimisticResponse.length === 0) {
        return entities;
    }
    let newEntities = entities;
    for (const mutation of mutationsWithOptimisticResponse) {
        newEntities = applyOptimisticUpdate(mutation, newEntities);
    }
    return newEntities;
}
function applyOptimisticUpdate({ document, optimisticCachePatches, optimisticResponse, variables }, cache) {
    if (optimisticResponse) {
        const mutationWithRequiredFields = GraphQLAddRemoveFields.addFields(document, ["__typename"]);
        const normalizedEntities = GraphQLEntityCache.normalize(mutationWithRequiredFields, variables, { data: optimisticResponse });
        return GraphQLEntityCache.mergeEntityCache(cache, normalizedEntities);
    }
    if (optimisticCachePatches) {
        const [newCache, newStaleEntites] = GQLCachePatch.apply(optimisticCachePatches, cache, getStaleEntities(cache));
        const newCacheWithStaleEntities = setStaleEntities(newCache, newStaleEntites);
        return newCacheWithStaleEntities;
    }
    return cache;
}
const __STALE_ENTITIES = "__STALE_ENTITIES";
function getStaleEntities(cache) {
    return cache[__STALE_ENTITIES] || {};
}
function setStaleEntities(cache, staleEntities) {
    // (cache as any)[__STALE_ENTITIES] = staleEntities;
    return Object.assign(Object.assign({}, cache), { [__STALE_ENTITIES]: staleEntities });
}
//# sourceMappingURL=mutations-queue.js.map